import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AppStoreProvider } from "./components/AppStore";
import MobileFrame from "./components/MobileFrame";
import Splash from "./screens/Splash";
import Onboarding from "./screens/Onboarding";
import Auth from "./screens/Auth";
import HomeScreen from "./screens/Home";
import Explore from "./screens/Explore";
import TaskDetail from "./screens/TaskDetail";
import ParentApproval from "./screens/ParentApproval";
import Safety from "./screens/Safety";
import Earnings from "./screens/Earnings";
import Academy from "./screens/Academy";
import CalendarScreen from "./screens/Calendar";
import Profile from "./screens/Profile";
import Notifications from "./screens/Notifications";
import Settings from "./screens/Settings";
import NeighborHome from "./screens/NeighborHome";
import PostJob from "./screens/PostJob";
import ParentPortal from "./screens/ParentPortal";
import Ranks from "./screens/Ranks";

function App() {
  return (
    <div className="App">
      <AppStoreProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<MobileFrame />}>
              <Route path="/" element={<Splash />} />
              <Route path="/onboarding" element={<Onboarding />} />
              <Route path="/auth" element={<Auth />} />
              <Route path="/home" element={<HomeScreen />} />
              <Route path="/explore" element={<Explore />} />
              <Route path="/task/:id" element={<TaskDetail />} />
              <Route path="/approval/:id" element={<ParentApproval />} />
              <Route path="/safety" element={<Safety />} />
              <Route path="/earnings" element={<Earnings />} />
              <Route path="/academy" element={<Academy />} />
              <Route path="/calendar" element={<CalendarScreen />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/notifications" element={<Notifications />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/neighbor" element={<NeighborHome />} />
              <Route path="/post" element={<PostJob />} />
              <Route path="/parent" element={<ParentPortal />} />
              <Route path="/ranks" element={<Ranks />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AppStoreProvider>
    </div>
  );
}

export default App;
